import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Col, Form, Row } from 'react-bootstrap';
import searchIcon from '../../assets/images/Dashboard/search-icon.svg'
import calendar from '../../assets/images/Dashboard/calendar-icon.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn from '../Buttons/Buttons';
import Select from 'react-select';
import AuditTrialTable from './AuditTrialTable';
import Download from '../MainSection/Download/Download';
import { useDispatch, useSelector } from 'react-redux';
import { loadAuditTrialData, loadModuleNameDropdownDataForSystemLogging } from '../../redux/action';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Document, Packer, Table, TableRow, TableCell, Paragraph } from "docx";
import { saveAs } from "file-saver";
import html2canvas from 'html2canvas';

const AuditTrial = () => {

    let dispatch = useDispatch();

    const { getAuditTrialData } = useSelector((state) => state.data);
    const { getModuleNameForSystemLogging } = useSelector((state) => state.data);
    const { totalDataCount } = useSelector((state) => state.data);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedModule, setSelectedModule] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10); // Set initial rows per page

    useEffect(() => {
        dispatch(loadAuditTrialData(fromDate, toDate, searchQuery, selectedModule, rowsPerPage, page + 1, setLoading));
    }, [dispatch, fromDate, toDate, searchQuery, selectedModule, page, rowsPerPage, setLoading]);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    useEffect(() => {
        dispatch(loadModuleNameDropdownDataForSystemLogging());
    }, [])

    const handleModuleSelection = (selectedOption) => {
        if (selectedOption) {
            const moduleName = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedModule(moduleName);  // Store StatusID in state
        }
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    const handleClearFilters = () => {
        setFromDate(null);
        setToDate(null);
        setSearchQuery("");
        setSearchText("");
        setSelectedModule("");
    }

    // Search trigger function
    const handleSearchClick = () => {
        setSearchQuery(searchText); // Set the search query only when the button is clicked
    };

    // Function to handle Excel download
    const handleDownloadExcel = () => {
        // Prepare data to be written to Excel (complainEscalationData)
        const dataToExport = getAuditTrialData?.map(item => ({
            "TIME STAMP": item.Date || "NA",
            "USER": item.UpdatedBy || "NA",
            "MODULES": item.ModuleName || "NA",
            "ACTIVITY TYPE": item.Type || "NA",
            "DESCRIPTION": item.Description || "NA",
        })) || [];

        // Create a new workbook
        const ws = XLSX.utils.json_to_sheet(dataToExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "ActivetyLog");

        // Generate Excel file and trigger the download
        XLSX.writeFile(wb, 'activity_Log.xlsx');
    };

    // Function to handle PDF download
    const handleDownloadPDF = () => {
        const doc = new jsPDF({ orientation: 'landscape' }); // Landscape for more width

        // Title
        doc.setFontSize(18);
        doc.text("Activity Log Data", 14, 20);

        const dataToExport = getAuditTrialData?.map(item => ([
            item.Date || "NA",
            item.UpdatedBy || "NA",
            item.ModuleName || "NA",
            item.Type || "NA",
            item.Description || "NA",
        ])) || [];

        const columns = [
            { title: "TIME STAMP", dataKey: "timeStamp" },
            { title: "USER", dataKey: "user" },
            { title: "MODULES", dataKey: "module" },
            { title: "ACTIVITY TYPE", dataKey: "activityType" },
            { title: "DESCRIPTION", dataKey: "description" },
        ];

        // Generate table
        doc.autoTable({
            head: [columns],
            body: dataToExport,
            startY: 30,
            tableWidth: 'auto', // Auto-adjust table to fit page
            styles: {
                fontSize: 8,
                cellPadding: 2,
                overflow: 'linebreak',
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: [255, 255, 255],
                halign: 'start',
            },
        });

        // Save PDF
        doc.save('activity_log.pdf');
    };

    const handleDownloadWord = () => {
        if (!getAuditTrialData || getAuditTrialData.length === 0) {
            console.error("No data available for export.");
            alert("No data to export!");
            return;
        }

        // Prepare data to be added to the Word document
        const dataToExport = getAuditTrialData.map(item => [
            String(item?.Date || "NA"),  // Explicitly convert to string
            String(item?.UpdatedBy || "NA"),  // Explicitly convert to string
            String(item?.ModuleName || "NA"),  // Explicitly convert to string
            String(item?.Type || "NA"),  // Explicitly convert to string
            String(item?.Description || "NA"),  // Explicitly convert to string
        ]);

        // Define the headers for the table in the Word document
        const headers = [
            "TIME STAMP", "USER", "MODULES", "ACTIVITY TYPE", "DESCRIPTION",
        ];

        // Create table rows for the document
        const tableRows = [
            // Header Row
            new TableRow({
                children: headers.map(header => new TableCell({ children: [new Paragraph(header)] }))
            }),
            // Data Rows
            ...dataToExport.map(row =>
                new TableRow({
                    children: row.map(cell => new TableCell({ children: [new Paragraph(cell)] }))
                })
            ),
        ];

        // Create the table
        const table = new Table({
            rows: tableRows
        });

        // Create the document with metadata
        const doc = new Document({
            creator: "Activity Trial System",
            title: "Activity Trial Report",
            description: "A detailed report of activity trial.",
            sections: [  // Ensure that sections are properly passed as an array
                {
                    children: [table]
                }
            ]
        });

        // Generate and download the Word document
        Packer.toBlob(doc)
            .then(blob => saveAs(blob, "activity_trial.docx"))
            .catch(error => {
                console.error("Error generating Word document:", error);
                alert("An error occurred while generating the Word document. Check the console for details.");
            });
    };

    const handlePrint = () => {
        if (!getAuditTrialData || getAuditTrialData.length === 0) {
            console.error("No data available for printing.");
            alert("No data to print!");
            return;
        }

        // Prepare data to be added to the table
        const dataToExport = getAuditTrialData.map(item => [
            item.Date || "NA",
            item.UpdatedBy || "NA",
            item.ModuleName || "NA",
            item.Type || "NA",
            item.Description || "NA",
        ]);

        // Define the headers for the table in the printable version
        const headers = [
            "TIME STAMP", "USER", "MODULES", "ACTIVITY TYPE", "DESCRIPTION",
        ];

        // Create HTML table for printing
        let tableHtml = `
            <table border="1" style="border-collapse: collapse; width: 100%; font-family: Arial, sans-serif;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 8px; background-color: #f2f2f2; text-align: left;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 8px; text-align: left;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        // Create a print window
        const printWindow = window.open('', '', 'width=800,height=600');
        printWindow.document.write('<html><head><title>Activity Trial Report</title>');
        printWindow.document.write('<style>body { font-family: Arial, sans-serif; }</style>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<h1>Activity Trial Report</h1>');
        printWindow.document.write(tableHtml); // Insert the table
        printWindow.document.write('</body></html>');
        printWindow.document.close(); // Necessary for the document to load

        // Trigger the print dialog after content is loaded
        printWindow.print();
    };

    const handleDownloadImage = () => {
        if (!getAuditTrialData || getAuditTrialData.length === 0) {
            console.error("No data available for exporting.");
            alert("No data to export!");
            return;
        }

        const maxRowsPerPage = 50; // Adjust this for better performance
        const dataToExport = getAuditTrialData.slice(0, maxRowsPerPage).map(item => [
            item.Date || "NA",
            item.UpdatedBy || "NA",
            item.ModuleName || "NA",
            item.Type || "NA",
            item.Description || "NA",
        ]);

        const headers = ["TIME STAMP", "USER", "MODULES", "ACTIVITY TYPE", "DESCRIPTION"];

        // Create a hidden container for rendering
        const printContainer = document.createElement("div");
        printContainer.style.position = "absolute";
        printContainer.style.left = "-9999px";
        printContainer.style.backgroundColor = "#fff";
        printContainer.style.padding = "20px";
        printContainer.style.border = "1px solid #ccc";
        printContainer.style.fontFamily = "Arial, sans-serif";

        printContainer.innerHTML = `
            <h2 style="text-align: center;">Audit Trial Report</h2>
            <table border="1" style="border-collapse: collapse; width: 100%; text-align: left;">
                <thead>
                    <tr>
                        ${headers.map(header => `<th style="padding: 10px; background-color: #f2f2f2;">${header}</th>`).join('')}
                    </tr>
                </thead>
                <tbody>
                    ${dataToExport.map(row => `
                        <tr>
                            ${row.map(cell => `<td style="padding: 10px;">${cell}</td>`).join('')}
                        </tr>
                    `).join('')}
                </tbody>
            </table>
        `;

        document.body.appendChild(printContainer);

        // Wait for the DOM to render before capturing
        setTimeout(() => {
            html2canvas(printContainer, {
                scale: 2, // Keep scale moderate for performance
                useCORS: true,
                backgroundColor: "#fff",
            }).then(canvas => {
                document.body.removeChild(printContainer); // Cleanup

                canvas.toBlob(blob => {
                    if (!blob) {
                        console.error("Image generation failed.");
                        alert("Failed to generate image.");
                        return;
                    }

                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.download = "audit_trial_report.png";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }, "image/png");
            }).catch(err => {
                console.error("Error capturing image:", err);
                alert("Error generating image. Try again.");
                document.body.removeChild(printContainer);
            });
        }, 500);
    };


    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showDashboardLibraryButton={false}
                        showSaveCustomViewButton={false}
                        showAnalyticsButton={false}
                        showDownloadDropdown={true}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                <div className="customermanagement-content-container">
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Audit Trial</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <Col md={4} className='filters-col'>
                                    <div className='customermanagement-search'>
                                        <Form.Control
                                            type="search"
                                            placeholder='Search'
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                        />
                                        <img src={searchIcon} alt="" onClick={handleSearchClick} />
                                    </div>
                                </Col>
                                {/* <Col md={2} className='filters-col'> */}
                                <Select
                                    className="react-select-container complaint-status-select"
                                    classNamePrefix="react-select"
                                    placeholder="Select Modules"
                                    options={getModuleNameForSystemLogging}
                                    style={{ width: "100%" }}
                                    value={selectedModule ? getModuleNameForSystemLogging.find(module => module.value === selectedModule) : null}
                                    onChange={(selectedOption) => handleModuleSelection(selectedOption)}
                                />
                                {/* </Col> */}
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText='From'
                                            selected={fromDate}
                                            onChange={(date) => setFromDate(date)}
                                            maxDate={new Date()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <Col md={2} className='filters-col'>
                                    <div className='calendar-container'>
                                        <DatePicker
                                            className="select from-date"
                                            id="date-range-picker"
                                            dateFormat="dd/MM/yyyy"
                                            placeholderText='To'
                                            selected={toDate}
                                            onChange={(date) => setToDate(date)}
                                            maxDate={new Date()}
                                        />
                                        <img src={calendar} alt="" />
                                    </div>
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <AuditTrialTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                getAuditTrialData={getAuditTrialData}
                                loading={loading}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                setPage={setPage}
                                page={page}
                                totalDataCount={totalDataCount}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {/* {
                isModalOpen && <AddComplaintEsaclation
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                />
            } */}
            {/* {showColumnFilterModal && (
                <CustomerFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                />
            )}
            {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default AuditTrial;